__turbopack_context__.v({
  "canRotate": "cardImage-module-scss-module__myf75G__canRotate",
  "centerContainer": "cardImage-module-scss-module__myf75G__centerContainer",
  "fade-in": "cardImage-module-scss-module__myf75G__fade-in",
  "flipperButton": "cardImage-module-scss-module__myf75G__flipperButton",
  "rotated": "cardImage-module-scss-module__myf75G__rotated",
});
